import { Card, CardProps, SimpleGrid } from "@mantine/core";
import { useContext } from "react";
import { HiOutlineGift, HiOutlineShoppingCart } from "react-icons/hi2";
import CartDrawerStateContext from "../../context/CartDrawerStateContext";
import { RoutePaths } from "../../router";

function MainPageManageItemCard({
  title,
  icon,
  navTo,
  ...props
}: {
  title: string;
  icon?: React.ReactElement;
  navTo?: string;
  onClick?: () => void;
} & CardProps) {
  return (
    <Card
      className="flex flex-row gap-4 items-end justify-center border border-neutral-300 shadow-md hover:bg-neutral-50 text-sm"
      component={"a"}
      href={(navTo !== undefined && navTo) || undefined}
      onClick={props.onClick}
      {...props}
    >
      {icon && (
        <div className="w-1/5 flex flex-row items-center justify-center h-full">
          {icon}
        </div>
      )}
      <div className="h-full flex items-center justify-center text-xs">
        <b>{title}</b>
      </div>
    </Card>
  );
}

export default function MainPageManage() {
  const { setOpen } = useContext(CartDrawerStateContext);
  return (
    <div className="main-page-manage flex flex-col gap-4 ">
      {/* Header */}
      {/* <div className="px-4 pt-4">
        <Title order={3}>Quản lý</Title>
      </div> */}
      <div className="py-1"></div>

      <SimpleGrid cols={2} spacing={12} px={12}>
        <MainPageManageItemCard
          title={`Giỏ hàng của tôi`}
          icon={<HiOutlineShoppingCart size={20} />}
          onClick={() => {
            setOpen && setOpen(true);
          }}
        />
        <MainPageManageItemCard
          title={`Tất cả sản phẩm`}
          icon={<HiOutlineGift size={20} />}
          navTo={RoutePaths.Product}
        />
      </SimpleGrid>

      {/* <Flex justify={`center`} align={`center`}>
        <Button variant="outline" color="black">
          Xem tất cả
        </Button>
      </Flex> */}
    </div>
  );
}
